import axios from "axios";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import successToast from "../toast/successToast";
import errorToast from "../toast/errorToast";
import FormTextField from "../form/text";
import { url } from "../../config";
import { useParams } from "react-router-dom";

const CreateLocationModal = ({
  isOpen = false,
  onClose = () => {},
  listFnc = () => {},
}) => {
  const params = useParams();

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!isOpen) return null;

  const initialValues = {
    city_id: params?.id ?? "",
    main_location: "",
    sub_location: "",
    location_link: "",
  };

  const validationSchema = Yup.object().shape({
    main_location: Yup.string().required("Required"),
    sub_location: Yup.string(),
    location_link: Yup.string().required("Required"),
  });

  const handleSubmit = (values) => {
    axios
      .post(`${url}/model/locality/create`, values)
      .then((response) => {
        successToast(response.message);
        onClose();
        listFnc();
      })
      .catch((error) => {
        console.error("API Error:", error);
        errorToast(error?.response?.data?.message);
      });
  };

  return (
    <div
      className="fixed inset-0 z-50 bg-black bg-opacity-60 flex items-center justify-center"
      onClick={handleOverlayClick}
    >
      <div
        className="bg-white rounded-xl shadow-xl w-[45vw]  relative overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            enableReinitialize={true}
          >
            <Form>
              <div className="flex justify-between items-center  py-4 px-5  border-b-[1px] border-[#E0E0E0]">
                <h2 className="text-xl font-semibold capitalize">
                  Add Location
                </h2>
                <div className="flex gap-3 items-center">
                  <button className="px-4 py-1 border-[2px] border-primary bg-primary text-white rounded">
                    Save
                  </button>
                  <button
                    onClick={onClose}
                    className="px-4 py-1 bg-white border-[2px] border-errorColor text-errorColor rounded"
                  >
                    Cancel
                  </button>
                </div>
              </div>
              <div className="px-5 py-3">
                {/* <div className="my-5">
                  <FormDropDown
                    name={"city_id"}
                    label={"city_id"}
                    options={cityList}
                  />
                </div> */}
                <div className="my-4">
                  <FormTextField
                    name={"main_location"}
                    label={"main_location"}
                    placeholder={`Enter main_location`}
                    maxLength={70}
                  />
                </div>
                <div className="my-4">
                  <FormTextField
                    name={"sub_location"}
                    label={"sub_location"}
                    placeholder={`Enter sub_location`}
                    maxLength={70}
                  />
                </div>
                <div className="mt-4">
                  <FormTextField
                    name={"location_link"}
                    label={"location_link"}
                    placeholder={`Enter location_link`}
                    maxLength={70}
                  />
                </div>
              </div>
            </Form>
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default CreateLocationModal;
